import { LayoutProps } from "../../lib/types/pageWithLayouts";

const EmptyLayout: LayoutProps = ({ children }) => {
  return <>{children}</>;
};
export default EmptyLayout;
